export const DASHBOARD_STATISTICS_REQUEST = 'DASHBOARD_STATISTICS_REQUEST';
